import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { UncheckIcon } from "assets/svgIcons";
import { CheckIcon } from "assets/svgIcons";
import TimeIcon from "assets/svgIcons/TimeIcon";
import {
  Container,
  Header,
  CheckBoxWrapper,
  BodyWrapper,
  FormWrapper,
  AddFeatureSetDatePickerWrapper,
  MobileSection,
} from "pages/Admin/Features/FeaturesStyled";
import { CircleBtn, MobileHeader, PopUpContainer } from "assets/css/globle";
import PlusIcon from "assets/svgIcons/PlusIcon";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Stack } from "@mui/system";
import { FormGroup, Grid, Modal, Typography } from "@mui/material";
import { COMMON_SERVICES } from "../../../redux/reduxToolkitServices/_commonServices/commonServices";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { uuid } from "../../../_helperFunctions/uuid";
import EditSqrIcon from "assets/svgIcons/EditIcon";
import ModalCloseIcon from "assets/svgIcons/ModalCloseIcon";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { SITEID_GLOBAL_STATE } from "globalStore/globalStore";
import SliderLeftIcon from "assets/svgIcons/SliderLeftIcon";
import SliderRightIcon from "assets/svgIcons/SliderRightIcon";
import { useTranslation } from "react-i18next";
import { useHookstate } from "@hookstate/core";
import TodayDateActionBar from "commonComponents/Calendar/todayDateActionBar";

const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
};

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <SliderRightIcon />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <SliderLeftIcon />
    </div>
  );
}
export const Features = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [open2, setOpen2] = useState(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => setOpen2(false);
  const [showExpired, setShowExpired] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showDiscardPopup, setShowDiscardPopup] = useState(false);
  const [featuresArray, setFeaturesArray] = useState([]);
  const [setModalOpener, setModalOpenerHandler] = useState(false);
  const [enableAddFeaturesButton, setenableAddFeaturesButton] = useState(true);
  const [enableEditFeaturesButton, setEnableEditFeaturesButton] = useState(true);
  const [saveCheckboxInput, setSaveCheckboxInput] = useState({
    carControl: false,
    golferExperience: false,
    flyovers: false,
    admanEvents: false,
    memberCars: false,
    service: false,
    realTimeTracking: false,
    tournamentScoring: false,
    admanPro: false,
    commercial: false,
    survey: false,
    visagBluetooth: false,
    weather: false,
  });

  const [saveCheckboxInput2, setSaveCheckboxInput2] = useState({
    carControl2: false,
    golferExperience2: false,
    flyovers2: false,
    admanEvents2: false,
    memberCars2: false,
    service2: false,
    realTimeTracking2: false,
    tournamentScoring2: false,
    admanPro2: false,
    commercial2: false,
    survey2: false,
    visagBluetooth2: false,
    weather2: false,
  });

  const [featureListData, setFeatureListData] = useState([]);
  const [featuresArray2, setFeaturesArray2] = useState([]);
  const [editFeatureData, setEditFeatureData] = useState({});
  const [dateIntervals, setDateIntervals] = useState([]);
  const [currentId, setCurrentId] = useState(null);
  const { getFeatureSetState, siteSettingsData, setNewFeatureStateStatus } = useSelector((state) => state?.commonReducers) || [];

  useEffect(() => {
    dispatch(COMMON_SERVICES.getFeatureSetServices(siteId.get()));
  }, []);

  useEffect(() => {
    if (setNewFeatureStateStatus === "success") {
      dispatch(COMMON_SERVICES.getFeatureSetServices(siteId.get()));
      dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
    }
  }, [setNewFeatureStateStatus]);

  useEffect(() => {
    if (getFeatureSetState && getFeatureSetState?.featureSets?.length !== 0) {
      let dateGetter =
        getFeatureSetState &&
        getFeatureSetState?.featureSets?.map((item) => {
          return {
            startDateData: item?.startDate
              ? moment(item?.startDate).format("DD/MM/YYYY")
              : "",
            endDateData: item?.endDate
              ? moment(item?.endDate).format("DD/MM/YYYY")
              : "",
          };
        });
      setDateIntervals(dateGetter);
    }
  }, [getFeatureSetState]);

  useEffect(() => {
    if (getFeatureSetState && getFeatureSetState?.length !== 0) {
      getFeatureSetState &&
        getFeatureSetState?.featureSets.forEach((value) => {
          let featureArrayData = value?.features?.split("");
          setSaveCheckboxInput2({
            carControl2: featureArrayData?.includes("C") ? true : false,
            golferExperience2: featureArrayData?.includes("G") ? true : false,
            flyovers2: featureArrayData?.includes("V") ? true : false,
            admanEvents2: featureArrayData?.includes("S") ? true : false,
            memberCars2: featureArrayData?.includes("D") ? true : false,
            service2: featureArrayData?.includes("H") ? true : false,
            realTimeTracking2: featureArrayData?.includes("T") ? true : false,
            tournamentScoring2: featureArrayData?.includes("E") ? true : false,
            admanPro2: featureArrayData?.includes("A") ? true : false,
            commercial2: featureArrayData?.includes("R") ? true : false,
            survey2: featureArrayData?.includes("Q") ? true : false,
            visagBluetooth2: featureArrayData?.includes("B") ? true : false,
            weather2: featureArrayData?.includes("N") ? true : false,
          });
        });
    }
  }, [getFeatureSetState]);

  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
  }, [siteId.get()]);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getFeatureSetServices(siteId.get()));
  }, [siteId.get()]);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "calc(100% - 40px)",
    bgcolor: "#fff",
    borderRadius: 6,
    maxWidth: 600,
  };

  const crossButton = {
    position: "absolute",
    right: 20,
    top: 13,
    fontSize: 30,
    cursor: "pointer",
    whiteSpace: "nowrap",
  };
  const tableCheckBox = {
    margin: "4px 0px",
  };

  const checkBoxWrapper = {
    padding: "15px 10px",
  };

  const wrapper = {
    margin: "0px 2px 6px 3px",
  };

  const button = {
    borderColor: "#636F7C",
    padding: "5px 20px 5px 20px",
    fontSize: "14px",
    margin: "auto",
  };

  const addFeatureButton = {
    borderColor: "#636F7C",
    padding: "5px 20px 5px 20px",
    fontSize: "14px",
    margin: "auto",
    cursor: enableAddFeaturesButton ? "context-menu" : "pointer",
  };

  const editFeatureButton = {
    padding: "5px 20px 5px 20px",
    fontSize: "14px",
    margin: "auto",
    cursor: enableEditFeaturesButton ? "context-menu" : "pointer",
  };

  const displayFeatSetTermDates = function (date) {
    if (date) {
      let disp = moment.utc(date);
      let now = moment.utc(new Date().toISOString());
      if (siteSettingsData) {
        disp.utcOffset(-siteSettingsData.TimeZoneOffset); // convert to course's timezone for display here
        now.utcOffset(-siteSettingsData.TimeZoneOffset);
      }
      return disp.from(now);
    }
    return "-";
  };

  const displayFeatSetDBDates = function (date) {
    if (date) {
      let disp = moment.utc(date);
      if (siteSettingsData) disp.utcOffset(-siteSettingsData.TimeZoneOffset); // convert to course's timezone for display here
      return disp.format("HH:mm a");
    }
    return "-";
  };

  useEffect(() => {
    if (!showExpired) {
      let filterWithoutExpiredData =
        getFeatureSetState &&
          getFeatureSetState?.featureSets &&
          getFeatureSetState?.featureSets.length !== 0
          ? getFeatureSetState?.featureSets?.filter((data) => {
            let currentDate = new Date().getTime();
            let Edate =
              data.endDate !== null ? new Date(data.endDate).getTime() : null;
            if (Edate > currentDate || Edate === null) {
              return data;
            }
          })
          : [];
      setFeatureListData(filterWithoutExpiredData);
    }
  }, [getFeatureSetState]);

  useEffect(() => {
    if (!showExpired) {
      let filterWithoutExpiredData =
        getFeatureSetState &&
          getFeatureSetState?.featureSets &&
          getFeatureSetState?.featureSets.length !== 0
          ? getFeatureSetState?.featureSets?.filter((data) => {
            let currentDate = new Date().getTime();
            let Edate =
              data.endDate !== null ? new Date(data.endDate).getTime() : null;
            if (Edate > currentDate || Edate === null) {
              return data;
            }
          })
          : [];
      setFeatureListData(filterWithoutExpiredData);
    } else {
      const rows =
        getFeatureSetState &&
          getFeatureSetState?.featureSets &&
          getFeatureSetState?.featureSets.length !== 0
          ? getFeatureSetState?.featureSets?.map((row, i) => {
            return {
              ...row,
              id: row.Id,
              Start: moment(row?.startDate).unix(),
              End: moment(row?.endDate).unix(),
              created: moment(row?.createdDate).unix(),
              createdby: row?.createdBy,
              modified: moment(row?.lastModifiedDate).unix(),
              modifiedby: row?.lastModifiedBy,
            };
          })
          : [];
      setFeatureListData(rows);
    }
  }, [showExpired]);

  const isCurrentDateInRange = (params) => {
    const currentDate = moment();
    const startMoment = moment(params?.row?.startDate, "YYYY-MM-DD");
    const endMoment = moment(params?.row?.endDate, "YYYY-MM-DD");
    let count = 0;
    getFeatureSetState?.featureSets.map((el) => {
      const startMoment = moment(el?.startDate, "YYYY-MM-DD");
      const endMoment = moment(el?.endDate, "YYYY-MM-DD");
      if (currentDate.isBetween(startMoment, endMoment, null, "[]")) {
        count++;
      }
    });
    if (getFeatureSetState?.featureSets.length > 1 && count > 1) {
      return currentDate.isBetween(startMoment, endMoment, null, "[]");
    }
  };

  const columns = [
    {
      field: "Start",
      headerName: t("Start"),
      headerAlign: "center",
      minWidth: 130,
      headerClassName: "lastcolumnSeparator",
      cellClassName: "super-app-theme--cell",
      sortable: true,
      renderCell: (params) => {
        return (
          <div
            className="super-time-theme--cell"
            style={{
              color: isCurrentDateInRange(params) ? "#FF0000" : "#000000",
            }}
          >
            <TimeIcon
              color={isCurrentDateInRange(params) ? "#FF0000" : "#000000"}
            />
            <strong style={{ marginLeft: "5px" }}>
              {moment
                .utc(params?.row?.startDate)
                .utcOffset(-siteSettingsData?.TimeZoneOffset)
                .format("DD-MMM-YYYY")}
            </strong>
            <p style={{ textAlign: "center" }}>
              ({displayFeatSetTermDates(params?.row?.startDate)})
            </p>
          </div>
        );
      },
    },
    {
      field: "End",
      headerName: t("End"),
      minWidth: 130,
      headerAlign: "center",
      headerClassName: "lastcolumnSeparator",
      cellClassName: "super-app-theme--cell",
      sortable: true,
      renderCell: (params) => {
        return params.row.endDate === null ? (
          "-"
        ) : (
          <div
            className="super-time-theme--cell"
            style={{
              color: isCurrentDateInRange(params) ? "#FF0000" : "#000000",
            }}
          >
            <TimeIcon
              color={isCurrentDateInRange(params) ? "#FF0000" : "#000000"}
            />
            <strong style={{ marginLeft: "5px" }}>
              {moment
                .utc(params?.row?.endDate)
                .utcOffset(-siteSettingsData?.TimeZoneOffset)
                .format("DD-MMM-YYYY")}
            </strong>

            <p style={{ textAlign: "center" }}>
              ({displayFeatSetTermDates(params?.row?.endDate)})
            </p>
          </div>
        );
      },
    },
    {
      field: "created",
      headerName: t("Created"),
      headerAlign: "center",
      minWidth: 130,
      headerClassName: "lastcolumnSeparator",
      cellClassName: "super-app-theme--cell",
      renderCell: (params) => {
        return params.row.createdDate === null ? (
          "-"
        ) : (
          <div className="super-time-theme--cell">
            <TimeIcon />
            <strong style={{ marginLeft: "5px" }}>
              {moment
                .utc(params?.row?.createdDate)
                .utcOffset(-siteSettingsData?.TimeZoneOffset)
                .format("DD-MMM-YYYY")}
            </strong>
            <p style={{ textAlign: "center" }}>
              (at {displayFeatSetDBDates(params?.row?.createdDate)})
            </p>
          </div>
        );
      },
    },
    {
      field: "createdby",
      headerName: t("Created_By"),
      headerAlign: "center",
      minWidth: 200,
      align: "center",
      headerClassName: "lastcolumnSeparator",
      cellClassName: "super-app-theme--cell",
      renderCell: (params) => {
        return params.row.createdBy === null ? (
          "-"
        ) : (
          <div className="super-time-theme--cell">
            <strong style={{ marginLeft: "5px" }}>
              {params?.row?.createdBy}
            </strong>
          </div>
        );
      },
    },

    {
      field: "modified",
      headerName: t("Modified"),
      headerAlign: "center",
      align: "center",
      headerClassName: "lastcolumnSeparator",
      cellClassName: "super-app-theme--cell",
      minWidth: 130,
      renderCell: (params) => {
        return params.row.lastModifiedDate === null ? (
          ""
        ) : (
          <div className="super-time-theme--cell">
            <TimeIcon />
            <strong style={{ marginLeft: "5px" }}>
              {moment
                .utc(params?.row?.lastModifiedDate)
                .utcOffset(-siteSettingsData?.TimeZoneOffset)
                .format("DD-MMM-YYYY")}
            </strong>
            <p style={{ textAlign: "center" }}>
              (at {displayFeatSetDBDates(params?.row?.lastModifiedDate)})
            </p>
          </div>
        );
      },
    },
    {
      field: "modifiedby",
      headerName: t("Modified_By"),
      sortable: true,
      minWidth: 200,
      headerAlign: "center",
      align: "center",
      headerClassName: "lastcolumnSeparator",
      cellClassName: "super-app-theme--cell",
      renderCell: (params) => {
        return params.row.lastModifiedBy === null ? (
          "-"
        ) : (
          <div className="super-time-theme--cell">
            <strong>{params?.row?.lastModifiedBy}</strong>
          </div>
        );
      },
    },
    {
      field: "activatedFeatures",
      headerName: t("Activated_features"),
      headerAlign: "center",
      description: "This column has a value getter and is not sortable.",
      headerClassName: "lastcolumnSeparator",
      cellClassName: "super-app-theme--cell--activated",
      minWidth: 680,
      renderCell: (params) => {
        return (
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <FormGroup style={{ margin: "10px 0px" }}>
                <CheckBoxWrapper style={tableCheckBox}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="carControl2"
                        icon={<UncheckIcon />}
                        checkedIcon={<CheckIcon />}
                        readOnly
                        checked={
                          params?.row?.features &&
                            params?.row?.features.includes("C")
                            ? true
                            : false
                        }
                        value="C"
                      />
                    }
                    label={t("Car_Control")}
                  />
                </CheckBoxWrapper>

                <CheckBoxWrapper style={tableCheckBox}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="golferExperience2"
                        readOnly
                        checked={
                          params?.row?.features &&
                            params?.row?.features.includes("G")
                            ? true
                            : false
                        }
                        value="G"
                        icon={<UncheckIcon />}
                        checkedIcon={<CheckIcon />}
                      />
                    }
                    label={t("Golfer_Experience")}
                  />
                </CheckBoxWrapper>
                <CheckBoxWrapper style={tableCheckBox}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="flyovers2"
                        readOnly
                        checked={
                          params?.row?.features &&
                            params?.row?.features.includes("V")
                            ? true
                            : false
                        }
                        value="V"
                        icon={<UncheckIcon />}
                        checkedIcon={<CheckIcon />}
                      />
                    }
                    label={t("Flyovers")}
                  />
                </CheckBoxWrapper>
                <CheckBoxWrapper style={tableCheckBox}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="admanEvents2"
                        readOnly
                        checked={
                          params?.row?.features &&
                            params?.row?.features.includes("S")
                            ? true
                            : false
                        }
                        value="S"
                        icon={<UncheckIcon />}
                        checkedIcon={<CheckIcon />}
                      />
                    }
                    label={t("AdMan_Event")}
                  />
                </CheckBoxWrapper>
                <CheckBoxWrapper style={tableCheckBox}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="weather2"
                        readOnly
                        checked={
                          params?.row?.features &&
                            params?.row?.features.includes("N")
                            ? true
                            : false
                        }
                        value="N"
                        icon={<UncheckIcon />}
                        checkedIcon={<CheckIcon />}
                      />
                    }
                    label={t("Weather")}
                  />
                </CheckBoxWrapper>
              </FormGroup>
            </Grid>

            <Grid item xs={4}>
              <FormGroup style={{ margin: "10px 0px" }}>
                <CheckBoxWrapper style={tableCheckBox}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="memberCars2"
                        readOnly
                        checked={
                          params?.row?.features &&
                            params?.row?.features.includes("D")
                            ? true
                            : false
                        }
                        value="D"
                        icon={<UncheckIcon />}
                        checkedIcon={<CheckIcon />}
                      />
                    }
                    label={t("Member_cars")}
                  />
                </CheckBoxWrapper>

                <CheckBoxWrapper style={tableCheckBox}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="service2"
                        readOnly
                        checked={
                          params?.row?.features &&
                            params?.row?.features.includes("H")
                            ? true
                            : false
                        }
                        value="H"
                        icon={<UncheckIcon />}
                        checkedIcon={<CheckIcon />}
                      />
                    }
                    label={t("Service")}
                  />
                </CheckBoxWrapper>

                <CheckBoxWrapper style={tableCheckBox}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="survey2"
                        readOnly
                        checked={
                          params?.row?.features &&
                            params?.row?.features.includes("Q")
                            ? true
                            : false
                        }
                        value="Q"
                        icon={<UncheckIcon />}
                        checkedIcon={<CheckIcon />}
                      />
                    }
                    label="Survey"
                  />
                </CheckBoxWrapper>
                <CheckBoxWrapper style={tableCheckBox}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="visagBluetooth2"
                        readOnly
                        checked={
                          params?.row?.features &&
                            params?.row?.features.includes("B")
                            ? true
                            : false
                        }
                        value="B"
                        icon={<UncheckIcon />}
                        checkedIcon={<CheckIcon />}
                      />
                    }
                    label="Visage bluetooth"
                  />
                </CheckBoxWrapper>
              </FormGroup>
            </Grid>

            <Grid item xs={4}>
              <FormGroup style={{ margin: "10px 0px" }}>
                <CheckBoxWrapper style={tableCheckBox}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="realTimeTracking2"
                        readOnly
                        checked={
                          params?.row?.features &&
                            params?.row?.features.includes("T")
                            ? true
                            : false
                        }
                        value="T"
                        icon={<UncheckIcon />}
                        checkedIcon={<CheckIcon />}
                      />
                    }
                    label={t("Real-time_tracking")}
                  />
                </CheckBoxWrapper>
                <CheckBoxWrapper style={tableCheckBox}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="tournamentScoring2"
                        readOnly
                        checked={
                          params?.row?.features &&
                            params?.row?.features.includes("E")
                            ? true
                            : false
                        }
                        value="E"
                        icon={<UncheckIcon />}
                        checkedIcon={<CheckIcon />}
                      />
                    }
                    label={t("Tournament_scoring")}
                  />
                </CheckBoxWrapper>
                <CheckBoxWrapper style={tableCheckBox}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="admanPro2"
                        readOnly
                        checked={
                          params?.row?.features &&
                            params?.row?.features.includes("A")
                            ? true
                            : false
                        }
                        value="A"
                        icon={<UncheckIcon />}
                        checkedIcon={<CheckIcon />}
                      />
                    }
                    label="AdMan Pro"
                  />
                </CheckBoxWrapper>
                <CheckBoxWrapper style={tableCheckBox}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="commercial2"
                        readOnly
                        checked={
                          params?.row?.features &&
                            params?.row?.features.includes("R")
                            ? true
                            : false
                        }
                        value="R"
                        icon={<UncheckIcon />}
                        checkedIcon={<CheckIcon />}
                      />
                    }
                    label="Commercial"
                  />
                </CheckBoxWrapper>
              </FormGroup>
            </Grid>
          </Grid>
        );
      },
    },
    {
      field: "action",
      headerName: t("Action"),
      headerAlign: "center",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      headerClassName: "lastcolumnSeparator",
      cellClassName: "super-app-theme--cell",
      minWidth: 120,
      renderCell: (params) => {
        return (
          <CircleBtn style={button} onClick={() => openEditModal(params)}>
            <EditSqrIcon /> {t("Edit")}
          </CircleBtn>
        );
      },
    },
  ];

  let productLevel = {
    VisageBasic: 0,
    VisageRT: 1,
    VisageRTPlus: 2,
    VisageTiered: 3,
    VisageSharkExp: 4,
  };

  let productLevelDesc = function (level) {
    level = siteSettingsData && siteSettingsData.ProductLevel;
    if (level === productLevel.VisageBasic) return "Visage basic";
    if (level === productLevel.VisageRT) return "Visage RT";
    if (level === productLevel.VisageRTPlus) return "Visage RT+";
    if (level === productLevel.VisageTiered) return "Visage tiered";
    if (level === productLevel.VisageSharkExp) return "Visage Shark Experience";
    return "Unknown product level";
  };

  const showPopupBox = () => {
    const style = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "400px",
      width: "calc(100% - 40px)",
      bgcolor: "#fff",
      borderRadius: "5px",
      overflow: "hidden",
    };

    return (
      <Modal
        open={showModal}
        onClose={() => setShowModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <Typography
              id="modal-modal-title"
              textAlign="center"
              variant="h6"
              component="h2"
            >
              {t("Notice")}
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              This Feature Set cannot be saved because it would create an
              overlap.
            </Typography>
            <div className="action-btn" style={{ marginTop: 20 }}>
              <button onClick={() => setShowModal(false)} className="primary">
                {t("Ok")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    );
  };

  const showDiscardPopupBox = () => {
    const style = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "400px",
      width: "calc(100% - 40px)",
      bgcolor: "#fff",
      borderRadius: "5px",
      overflow: "hidden",
    };

    return (
      <Modal
        open={showDiscardPopup}
        onClose={() => setShowDiscardPopup(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <Typography
              id="modal-modal-title"
              textAlign="center"
              variant="h6"
              component="h2"
            >
              Confirm cancel
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              Discard changes to this feature Set?
            </Typography>
            <div className="action-btn" style={{ marginTop: 20 }}>
              <button
                onClick={() => {
                  if (!enableAddFeaturesButton) {
                    setShowDiscardPopup(false);
                    handleClose();
                    setenableAddFeaturesButton(true);
                    setStartDate(null);
                    setEndDate(null);
                    setErrorHandler({
                      startDateError: "Start date is required",
                      endDateError: "",
                      otherError: "",
                    });
                  } else {
                    setShowDiscardPopup(false);
                    handleClose2();
                    setEnableEditFeaturesButton(true);
                  }
                }}
                className="primary"
              >
                {t("Ok")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    );
  };

  // ================================= Features Logic Starts =======================//

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [errorHandler, setErrorHandler] = useState({
    startDateError: "Start date is required",
    endDateError: "",
    otherError: "",
    totalDays: "",
  });

  const [startDate2, setStartDate2] = useState(null);
  const [endDate2, setEndDate2] = useState(null);
  const [errorHandler2, setErrorHandler2] = useState({
    startDateError: "",
    endDateError: "",
    otherError: "",
    totalDays: "",
  });

  const dateChecker = (newValue, dateDetector) => {
    if (dateDetector === "startDate") {
      if (newValue && newValue.format() !== "Invalid Date") {
        if (startDate && endDate) {
          var date = new Date(newValue); // Or the date you'd like converted.
          var startDateValue = new Date(
            date.getTime() - date.getTimezoneOffset() * 60000
          )
            .toISOString()
            .split("T");

          var date2 = new Date(endDate); // Or the date you'd like converted.
          var endDateValue = new Date(
            date2.getTime() - date2.getTimezoneOffset() * 60000
          )
            .toISOString()
            .split("T");

          if (startDateValue[0] === endDateValue[0]) {
            setErrorHandler({
              startDateError: "",
              endDateError: "",
              otherError: "0 days (end date = start date)",
              totalDays: "",
            });
            setStartDate(newValue);
            setenableAddFeaturesButton(true);
          } else if (startDateValue[0] > endDateValue[0]) {
            setErrorHandler({
              startDateError: "",
              endDateError: "",
              otherError: "0 days (end date is before start date)",
              totalDays: "",
            });
            setStartDate(newValue);
            setenableAddFeaturesButton(true);
          } else {
            let sDate = moment(new Date(newValue));
            let eDate = moment(new Date(endDate));
            let days = eDate.diff(sDate, "days");

            setErrorHandler({
              startDateError: "",
              endDateError: "",
              otherError: "",
              totalDays: `${days} day(s)`,
            });
            setStartDate(newValue);
            setenableAddFeaturesButton(false);

            let sDate2 = moment(new Date(newValue)).format("DD/MM/YYYY");
            let eDate2 = moment(new Date(endDate)).format("DD/MM/YYYY");

            if (dateIntervals && dateIntervals.length !== 0) {
              let data1 = dateIntervals.map((item) =>
                moment(sDate2).isBetween(
                  item?.startDateData,
                  item?.endDateData,
                  "days"
                )
              );

              let data2 = dateIntervals.map((item) =>
                moment(eDate2).isBetween(
                  item?.startDateData,
                  item?.endDateData,
                  "days"
                )
              );

              if (data1.includes(true) || data2.includes(true)) {
                setModalOpenerHandler(true);
              } else {
                setModalOpenerHandler(false);
              }
            }
          }
        } else {
          if (endDate) {
            var date = new Date(newValue); // Or the date you'd like converted.
            var startDateValue = new Date(
              date.getTime() - date.getTimezoneOffset() * 60000
            )
              .toISOString()
              .split("T");

            var date2 = new Date(endDate); // Or the date you'd like converted.
            var endDateValue = new Date(
              date2.getTime() - date2.getTimezoneOffset() * 60000
            )
              .toISOString()
              .split("T");

            if (startDateValue[0] === endDateValue[0]) {
              setErrorHandler({
                startDateError: "",
                endDateError: "",
                otherError: "0 days (end date = start date)",
                totalDays: "",
              });
              setStartDate(newValue);
              setenableAddFeaturesButton(true);
            } else if (startDateValue[0] > endDateValue[0]) {
              setErrorHandler({
                startDateError: "",
                endDateError: "",
                otherError: "0 days (end date is before start date)",
                totalDays: "",
              });
              setStartDate(newValue);
              setenableAddFeaturesButton(true);
            } else {
              let sDate = moment(new Date(newValue));
              let eDate = moment(new Date(endDate));
              let days = eDate.diff(sDate, "days");

              setErrorHandler({
                startDateError: "",
                endDateError: "",
                otherError: "",
                totalDays: `${days} day(s)`,
              });
              setStartDate(newValue);
              setenableAddFeaturesButton(false);

              let sDate2 = moment(new Date(newValue)).format("DD/MM/YYYY");
              let eDate2 = moment(new Date(endDate)).format("DD/MM/YYYY");

              if (dateIntervals && dateIntervals.length !== 0) {
                let data1 = dateIntervals.map((item) =>
                  moment(sDate2).isBetween(
                    item?.startDateData,
                    item?.endDateData,
                    "days"
                  )
                );

                let data2 = dateIntervals.map((item) =>
                  moment(eDate2).isBetween(
                    item?.startDateData,
                    item?.endDateData,
                    "days"
                  )
                );

                if (data1.includes(true) || data2.includes(true)) {
                  setModalOpenerHandler(true);
                } else {
                  setModalOpenerHandler(false);
                }
              }
            }
          } else {
            setStartDate(newValue);
            setErrorHandler({
              startDateError: "",
              endDateError: "End date is required",
              otherError: "",
              totalDays: "",
            });
            setenableAddFeaturesButton(true);
          }
        }
      } else {
        setErrorHandler({
          startDateError: "Start date is required",
          endDateError: "",
          otherError: "",
          totalDays: "",
        });
        setenableAddFeaturesButton(true);
      }
    } else {
      if (newValue && newValue.format() !== "Invalid Date") {
        if (endDate && startDate) {
          var date = new Date(startDate); // Or the date you'd like converted.
          var startDateValue = new Date(
            date.getTime() - date.getTimezoneOffset() * 60000
          )
            .toISOString()
            .split("T");

          var date2 = new Date(newValue); // Or the date you'd like converted.
          var endDateValue = new Date(
            date2.getTime() - date2.getTimezoneOffset() * 60000
          )
            .toISOString()
            .split("T");

          if (startDateValue[0] === endDateValue[0]) {
            setErrorHandler({
              startDateError: "",
              endDateError: "",
              otherError: "0 days (end date = start date)",
              totalDays: "",
            });
            setEndDate(newValue);
            setenableAddFeaturesButton(true);
          } else if (startDateValue[0] > endDateValue[0]) {
            setErrorHandler({
              startDateError: "",
              endDateError: "",
              otherError: "0 days (end date is before start date)",
              totalDays: "",
            });
            setEndDate(newValue);
            setenableAddFeaturesButton(true);
          } else {
            let sDate = moment(new Date(startDate));
            let eDate = moment(new Date(newValue));
            let days = eDate.diff(sDate, "days");

            setErrorHandler({
              startDateError: "",
              endDateError: "",
              otherError: "",
              totalDays: `${days} day(s)`,
            });
            setEndDate(newValue);
            setenableAddFeaturesButton(false);

            let sDate2 = moment(new Date(startDate)).format("DD/MM/YYYY");
            let eDate2 = moment(new Date(newValue)).format("DD/MM/YYYY");

            if (dateIntervals && dateIntervals.length !== 0) {
              let data1 = dateIntervals.map((item) =>
                moment(sDate2).isBetween(
                  item?.startDateData,
                  item?.endDateData,
                  "days"
                )
              );

              let data2 = dateIntervals.map((item) =>
                moment(eDate2).isBetween(
                  item?.startDateData,
                  item?.endDateData,
                  "days"
                )
              );

              if (data1.includes(true) || data2.includes(true)) {
                setModalOpenerHandler(true);
              } else {
                setModalOpenerHandler(false);
              }
            }
          }
        } else {
          if (startDate) {
            var date = new Date(startDate); // Or the date you'd like converted.
            var startDateValue = new Date(
              date.getTime() - date.getTimezoneOffset() * 60000
            )
              .toISOString()
              .split("T");

            var date2 = new Date(newValue); // Or the date you'd like converted.
            var endDateValue = new Date(
              date2.getTime() - date2.getTimezoneOffset() * 60000
            )
              .toISOString()
              .split("T");

            if (startDateValue[0] === endDateValue[0]) {
              setErrorHandler({
                startDateError: "",
                endDateError: "",
                otherError: "0 days (end date = start date)",
                totalDays: "",
              });
              setEndDate(newValue);
              setenableAddFeaturesButton(true);
            } else if (startDateValue[0] > endDateValue[0]) {
              setErrorHandler({
                startDateError: "",
                endDateError: "",
                otherError: "0 days (end date is before start date)",
                totalDays: "",
              });
              setEndDate(newValue);
              setenableAddFeaturesButton(true);
            } else {
              let sDate = moment(new Date(startDate));
              let eDate = moment(new Date(newValue));
              let days = eDate.diff(sDate, "days");
              setErrorHandler({
                startDateError: "",
                endDateError: "",
                otherError: "",
                totalDays: `${days} day(s)`,
              });
              setEndDate(newValue);
              setenableAddFeaturesButton(false);

              let sDate2 = moment(new Date(startDate)).format("DD/MM/YYYY");
              let eDate2 = moment(new Date(newValue)).format("DD/MM/YYYY");

              if (dateIntervals && dateIntervals.length !== 0) {
                let data1 = dateIntervals.map((item) =>
                  moment(sDate2).isBetween(
                    item?.startDateData,
                    item?.endDateData,
                    "days"
                  )
                );

                let data2 = dateIntervals.map((item) =>
                  moment(eDate2).isBetween(
                    item?.startDateData,
                    item?.endDateData,
                    "days"
                  )
                );

                if (data1.includes(true) || data2.includes(true)) {
                  setModalOpenerHandler(true);
                } else {
                  setModalOpenerHandler(false);
                }
              }
            }
          } else {
            setEndDate(newValue);
            setErrorHandler({
              startDateError: "Start date is required",
              endDateError: "",
              otherError: "",
              totalDays: "",
            });
            setenableAddFeaturesButton(true);
          }
        }
      } else {
        setErrorHandler({
          startDateError: "End date is required",
          endDateError: "",
          otherError: "",
          totalDays: "",
        });
        setenableAddFeaturesButton(true);
      }
    }
  };

  const dateChecker2 = (newValue, dateDetector) => {
    if (dateDetector === "startDate") {
      if (newValue && newValue.format() !== "Invalid Date") {
        if (startDate2 && endDate2) {
          var date = new Date(newValue); // Or the date you'd like converted.
          var startDateValue = new Date(
            date.getTime() - date.getTimezoneOffset() * 60000
          )
            .toISOString()
            .split("T");

          var date = new Date(endDate2); // Or the date you'd like converted.
          var endDateValue = new Date(
            date.getTime() - date.getTimezoneOffset() * 60000
          )
            .toISOString()
            .split("T");

          if (startDateValue[0] === endDateValue[0]) {
            setErrorHandler2({
              startDateError: "",
              endDateError: "",
              otherError: "0 days (end date = start date)",
              totalDays: "",
            });
            setStartDate2(newValue);
            setEnableEditFeaturesButton(true);
          } else if (startDateValue[0] > endDateValue[0]) {
            setErrorHandler2({
              startDateError: "",
              endDateError: "",
              otherError: "0 days (end date is before start date)",
              totalDays: "",
            });
            setStartDate2(newValue);
            setEnableEditFeaturesButton(true);
          } else {
            let sDate = moment(new Date(newValue));
            let eDate = moment(new Date(endDate2));
            let days = eDate.diff(sDate, "days");

            setErrorHandler2({
              startDateError: "",
              endDateError: "",
              otherError: "",
              totalDays: `${days} day(s)`,
            });
            setStartDate2(newValue);
            setEnableEditFeaturesButton(false);

            let sDate2 = moment(new Date(newValue)).format("DD/MM/YYYY");
            let eDate2 = moment(new Date(endDate2)).format("DD/MM/YYYY");

            if (dateIntervals && dateIntervals.length !== 0) {
              let data1 = dateIntervals.map((item) =>
                moment(sDate2).isBetween(
                  item?.startDateData,
                  item?.endDateData,
                  "days"
                )
              );

              let data2 = dateIntervals.map((item) =>
                moment(eDate2).isBetween(
                  item?.startDateData,
                  item?.endDateData,
                  "days"
                )
              );

              if (data1.includes(true) || data2.includes(true)) {
                setModalOpenerHandler(true);
              } else {
                setModalOpenerHandler(false);
              }
            }
          }
        } else {
          if (endDate2) {
            var date = new Date(newValue); // Or the date you'd like converted.
            var startDateValue = new Date(
              date.getTime() - date.getTimezoneOffset() * 60000
            )
              .toISOString()
              .split("T");

            var date = new Date(endDate2); // Or the date you'd like converted.
            var endDateValue = new Date(
              date.getTime() - date.getTimezoneOffset() * 60000
            )
              .toISOString()
              .split("T");

            if (startDateValue[0] === endDateValue[0]) {
              setErrorHandler2({
                startDateError: "",
                endDateError: "",
                otherError: "0 days (end date = start date)",
                totalDays: "",
              });
              setStartDate2(newValue);
              setEnableEditFeaturesButton(true);
            } else if (startDateValue[0] > endDateValue[0]) {
              setErrorHandler2({
                startDateError: "",
                endDateError: "",
                otherError: "0 days (end date is before start date)",
                totalDays: "",
              });
              setStartDate2(newValue);
              setEnableEditFeaturesButton(true);
            } else {
              let sDate = moment(new Date(newValue));
              let eDate = moment(new Date(endDate2));
              let days = eDate.diff(sDate, "days");

              setErrorHandler2({
                startDateError: "",
                endDateError: "",
                otherError: "",
                totalDays: `${days} day(s)`,
              });
              setStartDate2(newValue);
              setEnableEditFeaturesButton(false);

              let sDate2 = moment(new Date(newValue)).format("DD/MM/YYYY");
              let eDate2 = moment(new Date(endDate2)).format("DD/MM/YYYY");

              if (dateIntervals && dateIntervals.length !== 0) {
                let data1 = dateIntervals.map((item) =>
                  moment(sDate2).isBetween(
                    item?.startDateData,
                    item?.endDateData,
                    "days"
                  )
                );

                let data2 = dateIntervals.map((item) =>
                  moment(eDate2).isBetween(
                    item?.startDateData,
                    item?.endDateData,
                    "days"
                  )
                );

                if (data1.includes(true) || data2.includes(true)) {
                  setModalOpenerHandler(true);
                } else {
                  setModalOpenerHandler(false);
                }
              }
            }
          } else {
            setStartDate2(newValue);
            setErrorHandler2({
              startDateError: "",
              endDateError: "End date is required",
              otherError: "",
              totalDays: "",
            });
            setEnableEditFeaturesButton(true);
          }
        }
      } else {
        setErrorHandler2({
          startDateError: "Start date is required",
          endDateError: "",
          otherError: "",
          totalDays: "",
        });
        setEnableEditFeaturesButton(true);
      }
    } else {
      if (newValue && newValue.format() !== "Invalid Date") {
        if (endDate2 && startDate2) {
          var date = new Date(startDate2); // Or the date you'd like converted.
          var startDateValue = new Date(
            date.getTime() - date.getTimezoneOffset() * 60000
          )
            .toISOString()
            .split("T");

          var date = new Date(newValue); // Or the date you'd like converted.
          var endDateValue = new Date(
            date.getTime() - date.getTimezoneOffset() * 60000
          )
            .toISOString()
            .split("T");

          if (startDateValue[0] === endDateValue[0]) {
            setErrorHandler2({
              startDateError: "",
              endDateError: "",
              otherError: "0 days (end date = start date)",
              totalDays: "",
            });
            setEndDate2(newValue);
            setEnableEditFeaturesButton(true);
          } else if (startDateValue[0] > endDateValue[0]) {
            setErrorHandler2({
              startDateError: "",
              endDateError: "",
              otherError: "0 days (end date is before start date) C",
              totalDays: "",
            });
            setEndDate2(newValue);
            setEnableEditFeaturesButton(true);
          } else {
            let sDate = moment(new Date(startDate2));
            let eDate = moment(new Date(newValue));
            let days = eDate.diff(sDate, "days");

            setErrorHandler2({
              startDateError: "",
              endDateError: "",
              otherError: "",
              totalDays: `${days} day(s)`,
            });
            setEndDate2(newValue);
            setEnableEditFeaturesButton(false);

            let sDate2 = moment(new Date(startDate2)).format("DD/MM/YYYY");
            let eDate2 = moment(new Date(newValue)).format("DD/MM/YYYY");

            if (dateIntervals && dateIntervals.length !== 0) {
              let data1 = dateIntervals.map((item) =>
                moment(sDate2).isBetween(
                  item?.startDateData,
                  item?.endDateData,
                  "days"
                )
              );

              let data2 = dateIntervals.map((item) =>
                moment(eDate2).isBetween(
                  item?.startDateData,
                  item?.endDateData,
                  "days"
                )
              );

              if (data1.includes(true) || data2.includes(true)) {
                setModalOpenerHandler(true);
              } else {
                setModalOpenerHandler(false);
              }
            }
          }
        } else {
          if (startDate2) {
            var date = new Date(startDate2); // Or the date you'd like converted.
            var startDateValue = new Date(
              date.getTime() - date.getTimezoneOffset() * 60000
            )
              .toISOString()
              .split("T");

            var date = new Date(newValue); // Or the date you'd like converted.
            var endDateValue = new Date(
              date.getTime() - date.getTimezoneOffset() * 60000
            )
              .toISOString()
              .split("T");

            if (startDateValue[0] === endDateValue[0]) {
              setErrorHandler2({
                startDateError: "",
                endDateError: "",
                otherError: "0 days (end date = start date)",
                totalDays: "",
              });
              setEndDate2(newValue);
              setEnableEditFeaturesButton(true);
            } else if (startDateValue[0] > endDateValue[0]) {
              setErrorHandler2({
                startDateError: "",
                endDateError: "",
                otherError: "0 days (end date is before start date)",
                totalDays: "",
              });
              setEndDate2(newValue);
              setEnableEditFeaturesButton(true);
            } else {
              let sDate = moment(new Date(startDate2));
              let eDate = moment(new Date(newValue));
              let days = eDate.diff(sDate, "days");

              setErrorHandler2({
                startDateError: "",
                endDateError: "",
                otherError: "",
                totalDays: `${days} day(s)`,
              });
              setEndDate2(newValue);
              setEnableEditFeaturesButton(false);

              let sDate2 = moment(new Date(startDate2)).format("DD/MM/YYYY");
              let eDate2 = moment(new Date(newValue)).format("DD/MM/YYYY");

              if (dateIntervals && dateIntervals.length !== 0) {
                let data1 = dateIntervals.map((item) =>
                  moment(sDate2).isBetween(
                    item?.startDateData,
                    item?.endDateData,
                    "days"
                  )
                );

                let data2 = dateIntervals.map((item) =>
                  moment(eDate2).isBetween(
                    item?.startDateData,
                    item?.endDateData,
                    "days"
                  )
                );

                if (data1.includes(true) || data2.includes(true)) {
                  setModalOpenerHandler(true);
                } else {
                  setModalOpenerHandler(false);
                }
              }
            }
          } else {
            setEndDate2(newValue);
            setErrorHandler2({
              startDateError: "Start date is required",
              endDateError: "",
              otherError: "",
              totalDays: "",
            });
            setEnableEditFeaturesButton(true);
          }
        }
      } else {
        setErrorHandler2({
          startDateError: "End date is required",
          endDateError: "",
          otherError: "",
          totalDays: "",
        });
        setEnableEditFeaturesButton(true);
      }
    }
  };

  const handleSaveCheckboxInput = (e) => {
    const { name, checked, value } = e.target;
    if(name === 'golferExperience' && checked){
      setSaveCheckboxInput({
        ...saveCheckboxInput,
        ['commercial']: !checked,
        [name]: checked,
      })
    }
    else if(name === 'commercial' && checked)
      {
      setSaveCheckboxInput({
        ...saveCheckboxInput,
        ['golferExperience']: !checked,
        [name]: checked,
      })
    }
    else
    {
      setSaveCheckboxInput({
        ...saveCheckboxInput,
        [name]: checked,
      });
    }
    if (checked) {
      let finalArray = [...featuresArray, value];
      if(e.target.value === 'G')
      {
        finalArray = finalArray.filter((item) => item !== 'R');
      }
      else if(e.target.value === 'R')
      {
        finalArray = finalArray.filter((item) => item !== 'G');
      }
      setFeaturesArray(finalArray);
    } else {
      setFeaturesArray(featuresArray.filter((item) => item !== value));
    }
  };

  const handleSaveCheckboxInput2 = (e) => {
    const { name, checked, value } = e.target;
    // validation for dates
    if (!startDate2 || !endDate2) {
      setEnableEditFeaturesButton(true);
    } else {
      setEnableEditFeaturesButton(false);
    }
    if(name === 'commercial2' && checked){
      setSaveCheckboxInput2({
        ...saveCheckboxInput2,
        ['golferExperience2']: !checked,
        [name]:checked
      });
    }
    else if(name === 'golferExperience2' && checked){
      setSaveCheckboxInput2({
        ...saveCheckboxInput2,
        ['commercial2']: !checked,
        [name]:checked
      });
    }
    else
    {
      setSaveCheckboxInput2({
        ...saveCheckboxInput2,
        [name]: checked,
      });
    }
    if (checked) {
      let finalArray = [...featuresArray2, value];
      if(e.target.value === 'G')
      {
        finalArray = finalArray.filter((item) => item !== 'R');
      }
      if(e.target.value === 'R')
      {
        finalArray = finalArray.filter((item) => item !== 'G');
      }
      setFeaturesArray2(finalArray);
    } else {
      setFeaturesArray2(featuresArray2.filter((item) => item !== value));
    }
  };

  const openEditModal = (data) => {
    let {
      row: { features, startDate: apiStartDate, endDate: apiEndDate, Id } = {},
    } = data;
    setCurrentId(Id);
    setStartDate2(
      apiStartDate
        ? new Date(
          moment
            .utc(apiStartDate)
            .utcOffset(-siteSettingsData?.TimeZoneOffset)
            .format("DD-MMM-YYYY")
        )
        : null
    );
    setEndDate2(
      apiEndDate
        ? new Date(
          moment
            .utc(apiEndDate)
            .utcOffset(-siteSettingsData?.TimeZoneOffset)
            .format("DD-MMM-YYYY")
        )
        : null
    );
    if (apiStartDate && apiEndDate) {
      let date1 = moment(apiStartDate);
      let date2 = moment(apiEndDate);
      let days = date2.diff(date1, "days");

      setErrorHandler2({
        startDateError: "",
        endDateError: "",
        otherError: "",
        totalDays: `${days} day(s)`,
      });

      let startDateData =
        getFeatureSetState &&
        getFeatureSetState?.featureSets.map((item) => item.startDate);
      let endDateData =
        getFeatureSetState &&
        getFeatureSetState?.featureSets.map((item) => item.endDate);
      let matchStartDate = startDateData.map((item) => item.split("T")[0]);
      let matchEndDate = endDateData.map((item) => item.split("T")[0]);
      let sDate = moment.utc(apiStartDate).format().split("T")[0];
      let eDate = moment.utc(apiEndDate).format().split("T")[0];
    } else {
      if (apiStartDate) {
        setErrorHandler2({
          startDateError: "",
          endDateError: "End date is required",
          otherError: "",
          totalDays: "",
        });
      } else {
        setErrorHandler2({
          startDateError: "Start date is required",
          endDateError: "",
          otherError: "",
          totalDays: "",
        });
      }

      setModalOpenerHandler(false);
    }

    setEditFeatureData(data);
    setFeaturesArray2(features ? features?.split("") : "");
    let featureArrayData = features?.split("");
    setSaveCheckboxInput2({
      carControl2: featureArrayData?.includes("C") ? true : false, //
      golferExperience2: featureArrayData?.includes("G") ? true : false, //
      flyovers2: featureArrayData?.includes("V") ? true : false, //
      admanEvents2: featureArrayData?.includes("S") ? true : false, //
      memberCars2: featureArrayData?.includes("D") ? true : false,
      service2: featureArrayData?.includes("H") ? true : false,
      realTimeTracking2: featureArrayData?.includes("T") ? true : false, //
      tournamentScoring2: featureArrayData?.includes("E") ? true : false,
      admanPro2: featureArrayData?.includes("A") ? true : false,
      commercial2: featureArrayData?.includes("R") ? true : false,
      survey2: featureArrayData?.includes("Q") ? true : false,
      visagBluetooth2: featureArrayData?.includes("B") ? true : false,
      weather2: featureArrayData?.includes("N") ? true : false,
    });
    handleOpen2();
  };

  const openEditModal1 = (data) => {
    let { features, startDate, endDate } = data;
    setStartDate2(startDate ? new Date(startDate) : null);
    setEndDate2(endDate ? new Date(endDate) : null);
    if (startDate && endDate) {
      let date1 = moment(startDate);
      let date2 = moment(endDate);
      let days = date2.diff(date1, "days");

      setErrorHandler2({
        startDateError: "",
        endDateError: "",
        otherError: "",
        totalDays: `${days} day(s)`,
      });
    } else {
      if (startDate) {
        setErrorHandler2({
          startDateError: "",
          endDateError: "End date is required",
          otherError: "",
          totalDays: "",
        });
      } else {
        setErrorHandler2({
          startDateError: "Start date is required",
          endDateError: "",
          otherError: "",
          totalDays: "",
        });
      }

      setModalOpenerHandler(false);
    }

    setEditFeatureData(data);
    setFeaturesArray2(features ? features?.split("") : "");
    let featureArrayData = features?.split("");
    setSaveCheckboxInput2({
      carControl2: featureArrayData?.includes("C") ? true : false,
      golferExperience2: featureArrayData?.includes("G") ? true : false,
      flyovers2: featureArrayData?.includes("V") ? true : false,
      admanEvents2: featureArrayData?.includes("S") ? true : false,
      memberCars2: featureArrayData?.includes("D") ? true : false,
      service2: featureArrayData?.includes("H") ? true : false,
      realTimeTracking2: featureArrayData?.includes("T") ? true : false,
      tournamentScoring2: featureArrayData?.includes("E") ? true : false,
      admanPro2: featureArrayData?.includes("A") ? true : false,
      commercial2: featureArrayData?.includes("R") ? true : false,
      survey2: featureArrayData?.includes("Q") ? true : false,
      visagBluetooth2: featureArrayData?.includes("B") ? true : false,
      weather2: featureArrayData?.includes("N") ? true : false,
    });
    handleOpen2();
  };

  const saveNewFeatures = (saveHandlerDetector) => {
    if (saveHandlerDetector === "addFeatures") {
      let featuresList = featuresArray.join("");
      let startDateData =
        getFeatureSetState &&
        getFeatureSetState?.featureSets.map((item) => item.startDate);
      let endDateData =
        getFeatureSetState &&
        getFeatureSetState?.featureSets.map((item) => item.endDate);
      let matchStartDate = startDateData.map((item) => item.split("T")[0]);
      let matchEndDate = endDateData.map((item) => item.split("T")[0]);

      let dateStart = new Date(startDate); // Or the date you'd like converted.
      let sDate = new Date(
        dateStart.getTime() - dateStart.getTimezoneOffset() * 60000
      ).toISOString();
      let dateEnd = new Date(endDate); // Or the date you'd like converted.
      let eDate = new Date(
        dateEnd.getTime() - dateEnd.getTimezoneOffset() * 60000
      ).toISOString();

      if (featureListData?.length) {
        const filteredDataSet = featureListData.filter(
          (data) =>
            (data.startDate <= dateStart.toISOString().split(".")[0] &&
              data.endDate >= dateStart.toISOString().split(".")[0]) ||
            (data.startDate <= dateEnd.toISOString().split(".")[0] &&
              data.endDate >= dateEnd.toISOString().split(".")[0]) ||
            (data.startDate >= dateStart.toISOString().split(".")[0] &&
              data.endDate <= dateEnd.toISOString().split(".")[0])
        );

        if (filteredDataSet?.length) {
          return setShowModal(true);
        }
      }
      if (matchStartDate.includes(sDate?.split("T")[0])) {
        setShowModal(true);
      } else if (matchEndDate.includes(eDate?.split("T")[0])) {
        setShowModal(true);
      } else if (setModalOpener) {
        setShowModal(true);
      } else {
        let newFeaturesData = [
          {
            startDate: sDate.replace("Z", ""),
            endDate: eDate.replace("Z", ""),
            createdDate: "",
            createdBy: "",
            lastModifiedBy: null,
            lastModifiedDate: null,
            active: null,
            features: featuresList,
            Id: 0,
          },
        ];
        let featuresData = [
          ...getFeatureSetState?.featureSets,
          ...newFeaturesData,
        ];
        let apiDataModel = {
          featureSets: [...featuresData],
          siteId: getFeatureSetState?.siteId,
        };
        dispatch(COMMON_SERVICES.setNewFeaturesSetsService(apiDataModel, siteId.get()));
        handleClose();
      }
    } else {
      let featuresData = [];
      let featuresList = featuresArray2.join("");
      if (editFeatureData?.row) {
        var { row: { Id, createdDate, createdBy, active } = {} } =
          editFeatureData;
      } else {
        var { Id, createdDate, createdBy, active } = editFeatureData;
      }
      let dateStart = new Date(startDate2); // Or the date you'd like converted.
      let sDate = new Date(
        dateStart.getTime() - dateStart.getTimezoneOffset() * 60000
      ).toISOString();

      let dateEnd = new Date(endDate2); // Or the date you'd like converted.
      let eDate = new Date(
        dateEnd.getTime() - dateEnd.getTimezoneOffset() * 60000
      ).toISOString();

      let newData = featureListData.filter((data) => data.Id !== currentId);
      if (featureListData?.length > 1) {
        const filteredDataSet = newData.filter(
          (data) =>
            (data.startDate <= dateStart.toISOString().split(".")[0] &&
              data.endDate >= dateStart.toISOString().split(".")[0]) ||
            (data.startDate <= dateEnd.toISOString().split(".")[0] &&
              data.endDate >= dateEnd.toISOString().split(".")[0])
        );
        if (filteredDataSet?.length) {
          return setShowModal(true);
        }
      }
      let editFeaturesData = [
        {
          startDate: sDate,
          endDate: eDate,
          createdDate: createdDate,
          createdBy: createdBy,
          lastModifiedBy: null,
          lastModifiedDate: null,
          active: active,
          features: featuresList,
          Id: Id,
        },
      ];
      if (getFeatureSetState?.featureSets.length <= 1) {
        featuresData = [...editFeaturesData];
      } else {
        featuresData = [
          ...getFeatureSetState?.featureSets,
          ...editFeaturesData,
        ];
      }

      let apiDataModel = {
        featureSets: [...featuresData],
        siteId: getFeatureSetState?.siteId,
      };
      dispatch(COMMON_SERVICES.setNewFeaturesSetsService(apiDataModel, siteId.get()));
      handleClose2();
    }
  };

  // ================================= Features Logic End =======================//

  return (
    <Container>
      {showPopupBox()}
      {showDiscardPopupBox()}
      <MobileHeader>
        <h4>{t("Features")}</h4>
      </MobileHeader>
      <Header>
        <CheckBoxWrapper>
          <FormControlLabel
            control={
              <Checkbox
                icon={<UncheckIcon />}
                checkedIcon={<CheckIcon />}
                checked={showExpired}
                onChange={(e) => setShowExpired(e.target.checked)}
              />
            }
            label={t("Show_Expired_Feature_Sets")}
          />
        </CheckBoxWrapper>
        <div className="label-wrapper">
          <label name="ProdLevel">{t("Product_Level")}</label>
        </div>
        <div>
          <Typography
            sx={{ fontWeight: "bold", padding: "0 15px", color: "#f4f4d4" }}
          >
            {productLevelDesc()}
          </Typography>
        </div>

        <div className="no-bdr label-wrapper p-0 add-new-feature">
          <CircleBtn onClick={handleOpen}>
            <PlusIcon color="white" />
            {t("Add_New_Feature_Set")}
          </CircleBtn>
        </div>

        {/* Below Modal is For Adding New Features */}
        <div>
          <Modal
            open={open}
            onClose={() => {
              handleClose();
              setStartDate(null);
              setEndDate(null);
              setErrorHandler({
                startDateError: "Start date is required",
                endDateError: "",
                otherError: "",
              });
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography variant="h5" sx={{ mx: 4, my: 2 }}>
                {t("Add_Feature_Set")}
              </Typography>
              <span
                style={crossButton}
                onClick={() => {
                  if (!enableAddFeaturesButton) {
                    setShowDiscardPopup(true);
                  } else {
                    setenableAddFeaturesButton(true);
                    handleClose();
                    setStartDate(null);
                    setEndDate(null);
                    setErrorHandler({
                      startDateError: "Start date is required",
                      endDateError: "",
                      otherError: "",
                    });
                  }
                }}
              >
                <ModalCloseIcon />
              </span>
              <hr />
              <AddFeatureSetDatePickerWrapper>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <div className="label-wrapper">
                    <p className="label">{t("Start")}</p>
                    <DesktopDatePicker
                      // label="dd-mm-yyyy"
                      value={startDate}
                      className="test"
                      inputFormat="DD-MMM-YYYY"
                      onChange={(newValue) => {
                        dateChecker(newValue, "startDate");
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </div>
                  <div className="label-wrapper">
                    <p className="label">{t("End")}</p>
                    <DesktopDatePicker
                      // label="dd-mm-yyyy"
                      value={endDate}
                      className="test"
                      inputFormat="DD-MMM-YYYY"
                      onChange={(newValue) => {
                        dateChecker(newValue, "endDate");
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </div>
                </LocalizationProvider>
              </AddFeatureSetDatePickerWrapper>
              <p style={{ padding: "0 25px", fontSize: "14px" }}>
                {t("Duration")}{" "}
                <span style={{ color: "red", fontWeight: "bold" }}>
                  {errorHandler.startDateError && errorHandler.startDateError}
                  {errorHandler.endDateError && errorHandler.endDateError}
                  {errorHandler.otherError && errorHandler.otherError}
                </span>
                <span style={{ color: "black", fontWeight: "bold" }}>
                  {errorHandler.totalDays && errorHandler.totalDays}
                </span>
              </p>
              <FormWrapper
                className="modal-table-wrapper"
                style={checkBoxWrapper}
              >
                <Grid container>
                  <Grid item xs={12} sm={6}>
                    <FormGroup>
                      <CheckBoxWrapper style={wrapper}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="carControl"
                              checked={saveCheckboxInput.carControl}
                              onChange={handleSaveCheckboxInput}
                              value="C"
                              icon={<UncheckIcon />}
                              checkedIcon={<CheckIcon />}
                            />
                          }
                          label={t("Car_Control")}
                          name=""
                        />
                      </CheckBoxWrapper>
                      <CheckBoxWrapper style={wrapper}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="golferExperience"
                              checked={saveCheckboxInput.golferExperience}
                              onChange={handleSaveCheckboxInput}
                              value="G"
                              icon={<UncheckIcon />}
                              checkedIcon={<CheckIcon />}
                            />
                          }
                          label={t("Golfer_Experience")}
                        />
                      </CheckBoxWrapper>
                      <CheckBoxWrapper style={wrapper}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="flyovers"
                              checked={saveCheckboxInput.flyovers}
                              onChange={handleSaveCheckboxInput}
                              value="V"
                              icon={<UncheckIcon />}
                              checkedIcon={<CheckIcon />}
                            />
                          }
                          label={t("Flyovers")}
                        />
                      </CheckBoxWrapper>
                      <CheckBoxWrapper style={wrapper}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="admanEvents"
                              checked={saveCheckboxInput.admanEvents}
                              onChange={handleSaveCheckboxInput}
                              value="S"
                              icon={<UncheckIcon />}
                              checkedIcon={<CheckIcon />}
                            />
                          }
                          label={t("AdMan_Event")}
                        />
                      </CheckBoxWrapper>
                      <CheckBoxWrapper style={wrapper}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="weather"
                              checked={saveCheckboxInput.weather}
                              onChange={handleSaveCheckboxInput}
                              value="N"
                              icon={<UncheckIcon />}
                              checkedIcon={<CheckIcon />}
                            />
                          }
                          label={t("Weather")}
                        />
                      </CheckBoxWrapper>
                      <CheckBoxWrapper style={wrapper}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="memberCars"
                              checked={saveCheckboxInput.memberCars}
                              onChange={handleSaveCheckboxInput}
                              value="D"
                              icon={<UncheckIcon />}
                              checkedIcon={<CheckIcon />}
                            />
                          }
                          label={t("Member_cars")}
                        />
                      </CheckBoxWrapper>
                      <CheckBoxWrapper style={wrapper}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="service"
                              checked={saveCheckboxInput.service}
                              onChange={handleSaveCheckboxInput}
                              value="H"
                              icon={<UncheckIcon />}
                              checkedIcon={<CheckIcon />}
                            />
                          }
                          label={t("Service")}
                        />
                      </CheckBoxWrapper>
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormGroup>
                      <CheckBoxWrapper style={wrapper}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="realTimeTracking"
                              checked={saveCheckboxInput.realTimeTracking}
                              onChange={handleSaveCheckboxInput}
                              value="T"
                              icon={<UncheckIcon />}
                              checkedIcon={<CheckIcon />}
                            />
                          }
                          label={t("Real-time_tracking")}
                        />
                      </CheckBoxWrapper>
                      <CheckBoxWrapper style={wrapper}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="tournamentScoring"
                              checked={saveCheckboxInput.tournamentScoring}
                              onChange={handleSaveCheckboxInput}
                              value="E"
                              icon={<UncheckIcon />}
                              checkedIcon={<CheckIcon />}
                            />
                          }
                          label={t("Tournament_scoring")}
                        />
                      </CheckBoxWrapper>
                      <CheckBoxWrapper style={wrapper}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="admanPro"
                              checked={saveCheckboxInput.admanPro}
                              onChange={handleSaveCheckboxInput}
                              value="A"
                              icon={<UncheckIcon />}
                              checkedIcon={<CheckIcon />}
                            />
                          }
                          label={t("AdMan_Pro")}
                        />
                      </CheckBoxWrapper>
                      <CheckBoxWrapper style={wrapper}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="commercial"
                              checked={saveCheckboxInput.commercial}
                              onChange={handleSaveCheckboxInput}
                              value="R"
                              icon={<UncheckIcon />}
                              checkedIcon={<CheckIcon />}
                            />
                          }
                          label="Commercial"
                        />
                      </CheckBoxWrapper>
                      <CheckBoxWrapper style={wrapper}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="survey"
                              checked={saveCheckboxInput.survey}
                              onChange={handleSaveCheckboxInput}
                              value="Q"
                              icon={<UncheckIcon />}
                              checkedIcon={<CheckIcon />}
                            />
                          }
                          label="Survey"
                        />
                      </CheckBoxWrapper>
                      <CheckBoxWrapper style={wrapper}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="visagBluetooth"
                              checked={saveCheckboxInput.visagBluetooth}
                              onChange={handleSaveCheckboxInput}
                              value="B"
                              icon={<UncheckIcon />}
                              checkedIcon={<CheckIcon />}
                            />
                          }
                          label="Visage bluetooth"
                        />
                      </CheckBoxWrapper>
                    </FormGroup>
                  </Grid>
                </Grid>
              </FormWrapper>
              <hr />
              <Grid item xs={12} margin={2}>
                <CircleBtn
                  style={addFeatureButton}
                  disabled={enableAddFeaturesButton}
                  onClick={() => saveNewFeatures("addFeatures")}
                  className={!enableAddFeaturesButton ? "active" : ""}
                >
                  {t("Save")}
                </CircleBtn>
              </Grid>
            </Box>
          </Modal>
        </div>

        {/* Below Modal is For Edit Features */}
        <div>
          <Modal
            open={open2}
            onClose={() => {
              !enableEditFeaturesButton
                ? setShowDiscardPopup(true)
                : handleClose2() && setEnableEditFeaturesButton(true);
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography variant="h5" sx={{ mx: 4, my: 2 }}>
                {t("Edit_Feature_Set")}
              </Typography>
              <span
                style={crossButton}
                onClick={() => {
                  !enableEditFeaturesButton
                    ? setShowDiscardPopup(true)
                    : handleClose2() && setEnableEditFeaturesButton(true);
                }}
              >
                <ModalCloseIcon />
              </span>
              <hr />
              <AddFeatureSetDatePickerWrapper>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <div className="label-wrapper">
                    <p className="label">{t("Start")}</p>
                    <DesktopDatePicker
                      value={startDate2}
                      inputFormat="DD-MMM-YYYY"
                      onChange={(newValue) => {
                        dateChecker2(newValue, "startDate");
                      }}
                      renderInput={(params) => <TextField {...params} />}
                      PaperProps={{
                        sx: {
                          maxHeight: 350,
                          "& .MuiPickersLayout-contentWrapper": {
                            mb: 0,
                          }
                        }
                      }}
                      components={{
                        ActionBar: (props) => (
                          <TodayDateActionBar
                            onToday={() => {
                              const today = moment().startOf("day");
                              dateChecker2(today, "startDate");
                              props.onAccept?.();
                              props.onClose?.();
                            }}
                          />
                        ),
                      }}
                    />
                  </div>
                  <div className="label-wrapper">
                    <p className="label">{t("End")}</p>
                    <DesktopDatePicker
                      value={endDate2}
                      inputFormat="DD-MMM-YYYY"
                      onChange={(newValue) => {
                        dateChecker2(newValue, "endDate");
                      }}
                      renderInput={(params) => <TextField {...params} />}
                      PaperProps={{
                        sx: {
                          maxHeight: 350,
                          "& .MuiPickersLayout-contentWrapper": {
                            mb: 0,
                          }
                        }
                      }}
                      components={{
                        ActionBar: (props) => (
                          <TodayDateActionBar
                            onToday={() => {
                              const today = moment().startOf("day");
                              dateChecker2(today, "endDate");
                              props.onAccept?.();
                              props.onClose?.();
                            }}
                          />
                        ),
                      }}
                    />
                  </div>
                </LocalizationProvider>
              </AddFeatureSetDatePickerWrapper>
              <p style={{ padding: "0 25px", fontSize: "14px" }}>
                {t("Duration")}{" "}
                <span style={{ color: "red", fontWeight: "bold" }}>
                  {errorHandler2.startDateError && errorHandler2.startDateError}
                  {errorHandler2.endDateError && errorHandler2.endDateError}
                  {errorHandler2.otherError && errorHandler2.otherError}
                </span>
                <span style={{ color: "black", fontWeight: "bold" }}>
                  {errorHandler2.totalDays && errorHandler2.totalDays}
                </span>
              </p>
              <FormWrapper
                className="modal-table-wrapper"
                style={checkBoxWrapper}
              >
                <Grid container>
                  <Grid item xs={12} sm={6}>
                    <FormGroup>
                      <CheckBoxWrapper style={wrapper}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="carControl2"
                              checked={saveCheckboxInput2.carControl2}
                              onChange={handleSaveCheckboxInput2}
                              value="C"
                              icon={<UncheckIcon />}
                              checkedIcon={<CheckIcon />}
                            />
                          }
                          label={t("Car_Control")}
                        />
                      </CheckBoxWrapper>
                      <CheckBoxWrapper style={wrapper}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="golferExperience2"
                              checked={saveCheckboxInput2.golferExperience2}
                              onChange={handleSaveCheckboxInput2}
                              value="G"
                              icon={<UncheckIcon />}
                              checkedIcon={<CheckIcon />}
                            />
                          }
                          label={t("Golfer_Experience")}
                        />
                      </CheckBoxWrapper>
                      <CheckBoxWrapper style={wrapper}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="flyovers2"
                              checked={saveCheckboxInput2.flyovers2}
                              onChange={handleSaveCheckboxInput2}
                              value="V"
                              icon={<UncheckIcon />}
                              checkedIcon={<CheckIcon />}
                            />
                          }
                          label={t("Flyovers")}
                        />
                      </CheckBoxWrapper>
                      <CheckBoxWrapper style={wrapper}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="admanEvents2"
                              checked={saveCheckboxInput2.admanEvents2}
                              onChange={handleSaveCheckboxInput2}
                              value="S"
                              icon={<UncheckIcon />}
                              checkedIcon={<CheckIcon />}
                            />
                          }
                          label={t("AdMan_Event")}
                        />
                      </CheckBoxWrapper>
                      <CheckBoxWrapper style={wrapper}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="weather2"
                              checked={saveCheckboxInput2.weather2}
                              onChange={handleSaveCheckboxInput2}
                              value="N"
                              icon={<UncheckIcon />}
                              checkedIcon={<CheckIcon />}
                            />
                          }
                          label={t("Weather")}
                        />
                      </CheckBoxWrapper>
                      <CheckBoxWrapper style={wrapper}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="memberCars2"
                              checked={saveCheckboxInput2.memberCars2}
                              onChange={handleSaveCheckboxInput2}
                              value="D"
                              icon={<UncheckIcon />}
                              checkedIcon={<CheckIcon />}
                            />
                          }
                          label={t("Member_cars")}
                        />
                      </CheckBoxWrapper>
                      <CheckBoxWrapper style={wrapper}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="service2"
                              checked={saveCheckboxInput2.service2}
                              onChange={handleSaveCheckboxInput2}
                              value="H"
                              icon={<UncheckIcon />}
                              checkedIcon={<CheckIcon />}
                            />
                          }
                          label={t("Service")}
                        />
                      </CheckBoxWrapper>
                    </FormGroup>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormGroup>
                      <CheckBoxWrapper style={wrapper}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="realTimeTracking2"
                              checked={saveCheckboxInput2.realTimeTracking2}
                              onChange={handleSaveCheckboxInput2}
                              value="T"
                              icon={<UncheckIcon />}
                              checkedIcon={<CheckIcon />}
                            />
                          }
                          label={t("Real-time_tracking")}
                        />
                      </CheckBoxWrapper>
                      <CheckBoxWrapper style={wrapper}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="tournamentScoring2"
                              checked={saveCheckboxInput2.tournamentScoring2}
                              onChange={handleSaveCheckboxInput2}
                              value="E"
                              icon={<UncheckIcon />}
                              checkedIcon={<CheckIcon />}
                            />
                          }
                          label={t("Tournament_scoring")}
                        />
                      </CheckBoxWrapper>
                      <CheckBoxWrapper style={wrapper}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="admanPro2"
                              checked={saveCheckboxInput2.admanPro2}
                              onChange={handleSaveCheckboxInput2}
                              value="A"
                              icon={<UncheckIcon />}
                              checkedIcon={<CheckIcon />}
                            />
                          }
                          label={t("AdMan_Pro")}
                        />
                      </CheckBoxWrapper>
                      <CheckBoxWrapper style={wrapper}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="commercial2"
                              checked={saveCheckboxInput2.commercial2}
                              onChange={handleSaveCheckboxInput2}
                              value="R"
                              icon={<UncheckIcon />}
                              checkedIcon={<CheckIcon />}
                            />
                          }
                          label="Commercial"
                        />
                      </CheckBoxWrapper>
                      <CheckBoxWrapper style={wrapper}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="survey2"
                              checked={saveCheckboxInput2.survey2}
                              onChange={handleSaveCheckboxInput2}
                              value="Q"
                              icon={<UncheckIcon />}
                              checkedIcon={<CheckIcon />}
                            />
                          }
                          label="Survey"
                        />
                      </CheckBoxWrapper>
                      <CheckBoxWrapper style={wrapper}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="visagBluetooth2"
                              checked={saveCheckboxInput2.visagBluetooth2}
                              onChange={handleSaveCheckboxInput2}
                              value="B"
                              icon={<UncheckIcon />}
                              checkedIcon={<CheckIcon />}
                            />
                          }
                          label="Visage bluetooth"
                        />
                      </CheckBoxWrapper>
                    </FormGroup>
                  </Grid>
                </Grid>
              </FormWrapper>
              <hr />
              <Grid item xs={12} margin={2}>
                <CircleBtn
                  style={editFeatureButton}
                  disabled={enableEditFeaturesButton}
                  onClick={() => saveNewFeatures("editFeatures")}
                  className={enableEditFeaturesButton === false ? "active" : ""}
                >
                  {t("Save")}
                </CircleBtn>
              </Grid>
            </Box>
          </Modal>
        </div>
      </Header>
      <BodyWrapper className="no-pagination">
        <Box
          className="table-wrapper"
          sx={{
            width: "100%",
            "& .super-app-theme": {
              bgcolor: "transparent",
              "&:hover": {
                bgcolor: "transparent",
              },
            },
            "& .super-app-theme-active": {
              bgcolor: "#D6D69A",
              "&:hover": {
                bgcolor: "#D6D69A !important",
              },
            },
          }}
        >
          <DataGrid
            sx={{ backgroundColor: "#f4f4d4" }}
            components={{
              NoRowsOverlay: () => (
                <Stack
                  height="100%"
                  alignItems="center"
                  justifyContent="center"
                >
                  {t("No_data")}
                </Stack>
              ),
            }}
            rows={featureListData}
            columns={columns}
            disableSelectionOnClick
            disableColumnMenu
            getRowClassName={(params) =>
              params?.row?.active ? "super-app-theme-active" : "super-app-theme"
            }
            sortingOrder={["asc", "desc"]}
            getRowId={() => uuid()}
            getRowHeight={() => "auto"}
          />
        </Box>
      </BodyWrapper>
      <MobileSection>
        <div className="wrapper">
          <div className="slider-wrapper">
            <Slider {...settings}>
              {featureListData &&
                featureListData?.map((item, index) => {
                  return (
                    <span key={index}>
                      <div className="mobile-table-ui">
                        <div className="row">
                          <p>{t("Start")}</p>
                          <p>
                            {item?.startDate === null
                              ? "-"
                              : moment(item?.startDate).format("DD-MMM-YYYY")}
                          </p>
                          <p>({displayFeatSetTermDates(item?.startDate)})</p>
                        </div>
                        <div className="row">
                          <p>{t("End")}</p>
                          <p>
                            {item?.endDate === null
                              ? "-"
                              : moment(item?.endDate).format("DD-MMM-YYYY")}
                          </p>
                          <p>({displayFeatSetTermDates(item?.endDate)})</p>
                        </div>

                        <div className="row">
                          <p>{t("Created")}</p>
                          <p>
                            {item?.createdDate === null
                              ? "-"
                              : moment(item?.createdDate).format("DD-MMM-YYYY")}
                          </p>
                          <p>(at {displayFeatSetDBDates(item?.createdDate)})</p>
                        </div>
                        <div className="row">
                          <p>{"Created_By"}</p>
                          <p></p>
                          <p>{item?.createdBy}</p>
                        </div>
                        <div className="row">
                          <p>{t("Modified")}</p>
                          <p>
                            {item?.lastModifiedDate === null
                              ? "-"
                              : moment(item?.lastModifiedDate).format(
                                "DD-MMM-YYYY"
                              )}
                          </p>
                          <p>
                            (at {displayFeatSetDBDates(item?.lastModifiedDate)})
                          </p>
                        </div>
                        <div className="row">
                          <p>{t("Modified_By")}</p>
                          <p></p>
                          <p>{item?.lastModifiedBy}</p>
                        </div>
                      </div>
                      <div>
                        <div className="activated-features">
                          <div className="heading">
                            <h4>{t("Activated_features")}</h4>
                            <CircleBtn onClick={() => openEditModal1(item)}>
                              {t("Edit")}
                            </CircleBtn>
                          </div>
                          <div className="main-checkbox-wrapper">
                            <FormGroup style={{ margin: "10px 0px" }}>
                              <CheckBoxWrapper style={tableCheckBox}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="carControl2"
                                      readOnly
                                      checked={
                                        item?.features &&
                                          item?.features.includes("C")
                                          ? true
                                          : false
                                      }
                                      value="C"
                                      icon={<UncheckIcon />}
                                      checkedIcon={<CheckIcon />}
                                    />
                                  }
                                  label={t("Car_Control")}
                                />
                              </CheckBoxWrapper>

                              <CheckBoxWrapper style={tableCheckBox}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="golferExperience2"
                                      readOnly
                                      checked={
                                        item?.features &&
                                          item?.features.includes("G")
                                          ? true
                                          : false
                                      }
                                      value="G"
                                      icon={<UncheckIcon />}
                                      checkedIcon={<CheckIcon />}
                                    />
                                  }
                                  label={t("Golfer_Experience")}
                                />
                              </CheckBoxWrapper>
                              <CheckBoxWrapper style={tableCheckBox}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="flyovers2"
                                      readOnly
                                      checked={
                                        item?.features &&
                                          item?.features.includes("V")
                                          ? true
                                          : false
                                      }
                                      value="V"
                                      icon={<UncheckIcon />}
                                      checkedIcon={<CheckIcon />}
                                    />
                                  }
                                  label={t("Flyovers")}
                                />
                              </CheckBoxWrapper>
                              <CheckBoxWrapper style={tableCheckBox}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="admanEvents2"
                                      readOnly
                                      checked={
                                        item?.features &&
                                          item?.features.includes("S")
                                          ? true
                                          : false
                                      }
                                      value="S"
                                      icon={<UncheckIcon />}
                                      checkedIcon={<CheckIcon />}
                                    />
                                  }
                                  label={t("AdMan_Event")}
                                />
                              </CheckBoxWrapper>
                              <CheckBoxWrapper style={tableCheckBox}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="weather2"
                                      readOnly
                                      checked={
                                        item?.features &&
                                          item?.features.includes("N")
                                          ? true
                                          : false
                                      }
                                      value="N"
                                      icon={<UncheckIcon />}
                                      checkedIcon={<CheckIcon />}
                                    />
                                  }
                                  label={t("Weather")}
                                />
                              </CheckBoxWrapper>
                              <CheckBoxWrapper style={tableCheckBox}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="memberCars2"
                                      readOnly
                                      checked={
                                        item?.features &&
                                          item?.features.includes("D")
                                          ? true
                                          : false
                                      }
                                      value="D"
                                      icon={<UncheckIcon />}
                                      checkedIcon={<CheckIcon />}
                                    />
                                  }
                                  label={t("Member_cars")}
                                />
                              </CheckBoxWrapper>

                              <CheckBoxWrapper style={tableCheckBox}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="service2"
                                      readOnly
                                      checked={
                                        item?.features &&
                                          item?.features.includes("H")
                                          ? true
                                          : false
                                      }
                                      value="H"
                                      icon={<UncheckIcon />}
                                      checkedIcon={<CheckIcon />}
                                    />
                                  }
                                  label={t("Service")}
                                />
                              </CheckBoxWrapper>

                              <CheckBoxWrapper style={tableCheckBox}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="survey2"
                                      readOnly
                                      checked={
                                        item?.features &&
                                          item?.features.includes("Q")
                                          ? true
                                          : false
                                      }
                                      value="Q"
                                      icon={<UncheckIcon />}
                                      checkedIcon={<CheckIcon />}
                                    />
                                  }
                                  label="Survey"
                                />
                              </CheckBoxWrapper>
                              <CheckBoxWrapper style={tableCheckBox}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="visagBluetooth2"
                                      readOnly
                                      checked={
                                        item?.features &&
                                          item?.features.includes("B")
                                          ? true
                                          : false
                                      }
                                      value="B"
                                      icon={<UncheckIcon />}
                                      checkedIcon={<CheckIcon />}
                                    />
                                  }
                                  label="Visage bluetooth"
                                />
                              </CheckBoxWrapper>

                              <CheckBoxWrapper style={tableCheckBox}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="realTimeTracking2"
                                      readOnly
                                      checked={
                                        item?.features &&
                                          item?.features.includes("T")
                                          ? true
                                          : false
                                      }
                                      value="T"
                                      icon={<UncheckIcon />}
                                      checkedIcon={<CheckIcon />}
                                    />
                                  }
                                  label={t("Real-time_tracking")}
                                />
                              </CheckBoxWrapper>
                              <CheckBoxWrapper style={tableCheckBox}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="tournamentScoring2"
                                      readOnly
                                      checked={
                                        item?.features &&
                                          item?.features.includes("E")
                                          ? true
                                          : false
                                      }
                                      value="E"
                                      icon={<UncheckIcon />}
                                      checkedIcon={<CheckIcon />}
                                    />
                                  }
                                  label={t("Tournament_scoring")}
                                />
                              </CheckBoxWrapper>
                              <CheckBoxWrapper style={tableCheckBox}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="admanPro2"
                                      readOnly
                                      checked={
                                        item?.features &&
                                          item?.features.includes("A")
                                          ? true
                                          : false
                                      }
                                      value="A"
                                      icon={<UncheckIcon />}
                                      checkedIcon={<CheckIcon />}
                                    />
                                  }
                                  label="AdMan Pro"
                                />
                              </CheckBoxWrapper>
                              <CheckBoxWrapper style={tableCheckBox}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name="commercial2"
                                      readOnly
                                      checked={
                                        item?.features &&
                                          item?.features.includes("R")
                                          ? true
                                          : false
                                      }
                                      value="R"
                                      icon={<UncheckIcon />}
                                      checkedIcon={<CheckIcon />}
                                    />
                                  }
                                  label="Commercial"
                                />
                              </CheckBoxWrapper>
                            </FormGroup>
                          </div>
                        </div>
                      </div>
                    </span>
                  );
                })}
            </Slider>
          </div>
        </div>
      </MobileSection>
    </Container>
  );
};

export default Features;
